@import "./shared/styles/breakpoints.css";

.shell {
  display: grid;
  grid-template-columns: 1fr;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  min-width: 0;
}

@media (--md) {
  .shell {
    grid-template-columns: var(--p-sidenav-width-collapsed) 1fr;
  }

  .shell.pinned {
    grid-template-columns: auto 1fr;
  }

  .content {
    grid-column: 2;
  }
}
